import React, { useState } from 'react';
import Typography from '@visa/vds/typography'
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Fieldset from '@visa/vds/fieldset';
import Form from '@visa/vds/form';
import FormControl from '@visa/vds/form-control';
import Input from '@visa/vds/input';

function BillingLineForm(props) {
    const ReadOnly = props.ReadOnly;
    const billingLine = props.billingLine;
    const setBillingLineDetail = props.setBillingLineDetail;
    const formErrors = props.formErrors;
    const setFormErrors = props.setFormErrors;

    const updateCustomDescription = (idx, value) => {
        let items = [...billingLine.billingSubscriptions];
        let item = { ...items[idx], customDescription: value };
        items[idx] = item;
        setBillingLineDetail({ ...billingLine, billingSubscriptions: items });
    }

    const updateFormErrors = (e, errorText) => {
        let inputId = e.target.id;
        let errorIdx = formErrors.findIndex(el => el.id == inputId);
        if (!e.target.checkValidity() || e.target.required && !e.target.value.trim().length) {
            if (errorIdx == -1) {
                let error = {
                    id: inputId,
                    text: errorText
                };
                setFormErrors([...formErrors, error]);
            }
        } else {
            if (errorIdx != -1) {
                let temp = [...formErrors];
                temp.splice(errorIdx, 1);
                setFormErrors(temp);
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <Typography className="vss-field-label"><b>Line Number</b></Typography>
                    <Typography className="vss-field-value">{billingLine?.lineNumber}</Typography>
                </Col>
                <Col>
                    <Typography className="vss-field-label"><b>Description</b></Typography>
                    <Typography className="vss-field-value">{billingLine?.description}</Typography>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form style={{ marginTop: "-30px" }}>
                        <FormControl space="thirty">
                            <Input
                                label="Price (USD)"
                                name="price"
                                value={billingLine ? billingLine.price : ""}
                                readOnly={ReadOnly}
                                required
                                pattern="^\d*(\.\d{1,2})?$"
                                helpText="Enter a number with maximum 2 decimal places, e.g. 1000, 1000.5, 1000.50"
                                onChange={(e) => {
                                    if (!ReadOnly) {
                                        setBillingLineDetail({ ...billingLine, price: Number(e.target.value) });
                                        updateFormErrors(e, "Price is invalid.");
                                    }
                                }}
                                errorText="Price is invalid."                                
                                showErrorText
                                showHelpText
                            />
                        </FormControl>
                        {billingLine?.singleSubscription === true &&
                            billingLine?.billingSubscriptions.map((item, key) => (
                                <FormControl key={key}>
                                    <Input
                                        label="Custom Description"
                                        name="custom-description"
                                        value={item.customDescription}
                                        readOnly={ReadOnly}
                                        required
                                        onChange={(e) => {
                                            if (!ReadOnly) {
                                                updateCustomDescription(key, e.target.value);
                                                updateFormErrors(e, "Custom Description is invalid.");
                                            }
                                        }}
                                        errorText="Custom Description is invalid."
                                        showErrorText
                                    />
                                </FormControl>
                            ))
                        }
                    </Form>
                </Col>
            </Row>
            {billingLine?.singleSubscription === false &&
                <Row>
                    <Col>
                        <Form>
                            <Fieldset>
                                <legend><b>Custom Description</b></legend>
                                {billingLine?.billingSubscriptions.map((item, key) => (
                                    <FormControl key={key}>
                                        <Input
                                            label={item.subscriptionName ?? ""}
                                            name={"custom-description-" + key}
                                            value={item.customDescription}
                                            readOnly={ReadOnly}
                                            required
                                            onChange={(e) => {
                                                if (!ReadOnly) {
                                                    updateCustomDescription(key, e.target.value);
                                                    updateFormErrors(e, item.subscriptionName + " is invalid.");
                                                }
                                            }}
                                            errorText={item.subscriptionName + " is invalid."}
                                            showErrorText
                                        />
                                    </FormControl>
                                ))
                                }
                            </Fieldset>
                        </Form>
                    </Col>
                </Row>
            }
        </>
    );
}
export default BillingLineForm;
